/* Frost craft + discover — the Discover rows are pure CSS (see
   section-frost-craft-discover.css), so this only handles the
   craftsmanship video: play it while it's actually on screen instead of
   autoplaying immediately on page load. Same pattern as
   assets/frost-love-story.js. */
(function () {
  function initVideo(section) {
    var video = section.querySelector('[data-frost-craft-video]');
    if (!video) return;
    video.muted = true;

    if (!('IntersectionObserver' in window)) {
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
      return;
    }

    new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        var playPromise = video.play();
        if (playPromise && playPromise.catch) playPromise.catch(function () {});
      } else {
        video.pause();
      }
    }, { threshold: 0.25 }).observe(video);
  }

  document.querySelectorAll('[data-frost-craft-discover-section]').forEach(initVideo);
})();
